// src/services/ProgramacionService.js

const API_URL = "https://dev.dimalink.cl/api/ProgramacionesRiego";

/**
 * Obtener todas las programaciones de un módulo
 * @param {number} moduloId
 */
export async function obtenerProgramacionesPorModulo(moduloId) {
  try {
    const response = await fetch(`${API_URL}/por-modulo/${moduloId}`);
    if (!response.ok) throw new Error(await response.text());
    return await response.json();
  } catch (error) {
    console.error("❌ Error al obtener programaciones:", error);
    throw error;
  }
}

/**
 * Crear una nueva programación
 * @param {Object} programacion - objeto completo de programación
 */
export async function crearProgramacion(programacion) {
  try {
    const response = await fetch(`${API_URL}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(programacion),
    });
    if (!response.ok) throw new Error(await response.text());
    return await response.json();
  } catch (error) {
    console.error("❌ Error al crear programación:", error);
    throw error;
  }
}

/**
 * Actualizar una programación existente
 * @param {Object} programacion - objeto completo con programacionId
 */
export async function actualizarProgramacion(programacion) {
  try {
    const response = await fetch(`${API_URL}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(programacion),
    });
    if (!response.ok) throw new Error(await response.text());
    return await response.json();
  } catch (error) {
    console.error("❌ Error al actualizar programación:", error);
    throw error;
  }
}

/**
 * Eliminar una programación por ID
 * @param {number} programacionId
 */
export async function eliminarProgramacion(programacionId) {
  try {
    const response = await fetch(`${API_URL}/${programacionId}`, {
      method: "DELETE",
    });
    if (!response.ok) throw new Error(await response.text());
    return await response.json();
  } catch (error) {
    console.error("❌ Error al eliminar programación:", error);
    throw error;
  }
}
